var React = require('react');

function BackToTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m166.891792 9212.73002-4.150841-3.6462c-.115326-.09027-.241405-.10764-.378351-.05206-.136794.05564-.205474.15627-.205474.30219v2.1345c0 .10994-.092458.19905-.206535.19905h-7.744056c-.114077 0-.206535.0891-.206535.19904v2.26845c0 .10994.092458.19904.206535.19904h7.744131c.114077 0 .206535.08911.206535.19904v2.13451c0 .13906.068795.23969.205513.30201.137059.05579.263138.0347.378464-.06232l4.150841-3.68809c.07205-.0694.107981-.15259.107981-.2499 0-.09006-.036158-.16982-.108208-.23926","fill":"#fff","fillRule":"evenodd","transform":"matrix(0 -1 1 0 -9208.5 167.5)"}));
}

BackToTop.defaultProps = {"height":"14","viewBox":"0 0 9 14","width":"9"};

module.exports = BackToTop;

BackToTop.default = BackToTop;
